<fa-icon [ngClass]="colorClass" class="mr-2 ml-2" [icon]="icon" [popoverTitle]="title" [ngbPopover]="text"
    [placement]="placement" triggers="mouseenter:mouseleave" container="body"></fa-icon>